export const countryConfig: Record<string, number> = {
  AF: 3,
  AX: 5,
  AL: 15,
}
